import { render, staticRenderFns } from "./ContestAdwardComponent.vue?vue&type=template&id=ce8a6c48"
import script from "./ContestAdwardComponent.vue?vue&type=script&lang=js"
export * from "./ContestAdwardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports